import $ from 'jquery';

export default function initFormHero() {
    if($('.form-hero-section').length > 0) {
        let $section = $('.form-hero-section');
        let $form = $('.form-hero-section').find('form');
        $form.on('submitSuccess', function() {
            $section.find('.form-hero-section-form').hide();
            $section.find('.form-hero-section-form-thank-you').show();
        });
    }
}